export function getHadaImageSources(): {
  webp: string
  png: string
} {
  return {
    webp: '/hada/hada.webp',
    png: '/hada/hada.png'
  }
}
